import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Gabungkan class Tailwind dengan aman (menyelesaikan konflik utility). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format angka ke mata uang Rupiah. */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(value)
}

/** Format angka ringkas (1.2k, 3.4jt). */
export function formatCompactNumber(value: number): string {
  return new Intl.NumberFormat('id-ID', { notation: 'compact' }).format(value)
}

/** Format persentase dengan tanda. */
export function formatPercent(value: number): string {
  const sign = value > 0 ? '+' : ''
  return `${sign}${value.toFixed(1)}%`
}
